/* eslint-disable no-unused-vars */
import React, { useContext } from 'react';
import { CotizadorContext } from '../context';

const useDeliveryData = () => {
    const [state, setState] = useContext(CotizadorContext)


    const setDeliveryMethod = method => {
        setState(prevState => ({
            ...prevState,
            delivery: {
                ...prevState.delivery,
                method,
                distance: method === 'Servicio puerta a puerta' ? prevState?.distance : null,
                subMethod: method === 'Servicio puerta a puerta' ? 'para llevártelo' : null
            }
        }));
    }

    const setDeliveryDistance = distance => {
        setState(prevState => ({
            ...prevState,
            delivery: {
                ...prevState?.delivery,
                distance,

            }
        }));
    }

    const setDeliverySubMethod = subMethod => {
        setState(prevState => ({
            ...prevState,
            delivery: {
                ...prevState?.delivery,
                subMethod,

            }
        }));
    }

    return {
        delivery: state.delivery,
        setDeliveryMethod,
        setDeliverySubMethod,
        setDeliveryDistance
    };
}

export default useDeliveryData;